import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduce, intersection, values, keyBy, concat } from 'lodash';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import PathDisplay from '../../../../../components/search-path/path';
import SearchPath from '../../../../../components/search-path';

class ContactReferenceField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
    };
    this.removeRow = this.removeRow.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateSearchPath = this.updateSearchPath.bind(this);

  }

  openModal() {
    this.setState({ openModal: true });
  }

  closeModal() {
    this.setState({ openModal: false });
  }

  removeRow(i) {
    const newValue = [...this.props.value];
    newValue.splice(i, 1);
    this.props.onChange(newValue);
  }

  filterNodes(node) {
    const { fields } = node;
    return reduce(fields, (items, field) => {
      const validReference = intersection(field.reference_to, ['account', 'Account', 'User', 'systemuser', 'contact', 'Contact']).length > 0 && field.name !== 'contact_roles.contact_id';
      const idType = node.objectType === 'Contact' && field.is_key && field.type === 'id';
      const isValid = idType || validReference || (!field.isSystem && field.reference_to && field.reference_to.length > 0); // !isSystem = custom field
      if (isValid) {
        if (idType) {
          items.push({
            ...field,
            label: node.label,
            name: `${node.objectLabel} Info`,
          });
        } else {
          items.push(field);
        }
      }
      return items;
    }, []);
  }

  updateSearchPath(field) {
    const items = concat(this.props.value, [field]);
    const indexed = keyBy(items, (n) => {
      return n;
    });
    const newVals = values(indexed);
    this.props.onChange(newVals);
    this.closeModal();
  }

  renderModal() {
    const { openModal } = this.state;
    const { isAccount } = this.props;

    return (
      <Modal show={openModal} onHide={this.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Select Contact Field</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <SearchPath
              paths={[]}
              onUpdate={this.updateSearchPath}
              selectedSearchPaths={[]}
              filterNodes={this.filterNodes}
              startingNode={isAccount ? 'Account' : 'Opportunity'}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button bsStyle="default" onClick={this.closeModal}>Cancel</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  renderList() {
    const { value, isAccount } = this.props;
    if (!value || value.length === 0) {
      return null;
    }
    console.log('value', value)
    return (
      <div>
        <table className="table table-condensed table-bordered table-striped">
          <thead>
            <tr>
              <th>Custom Contact Field</th>
              <th width="100">Action</th>
            </tr>
          </thead>
          <tbody>
            {value.map((val, i) => {
              return (
                <tr key={val.join('|')}>
                  <td>
                    <PathDisplay startingNode={isAccount ? 'Account' : 'Opportunity'} paths={val} />
                  </td>
                  <td>
                    <Button
                      bsSize="xs"
                      bsStyle="default"
                      onClick={() => { this.removeRow(i); }}
                      disabled={this.props.disabled}
                    >
                      <Fa name="trash" /> Remove
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderList()}
        {this.renderModal()}
        <div>
          <Button byStyle="default" bsSize="sm" onClick={this.openModal} disabled={this.props.disabled}><Fa name="plus" /> Add Custom Contact Field</Button>
          <p />
        </div>
      </div>
    )
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

ContactReferenceField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAccount: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
ContactReferenceField.defaultProps = {
  isAccount: false,
  disabled: false,
  value: [],
  onChange: () => {},
};

export default connect(mapStateToProps)(ContactReferenceField);
